import UpperCaseText from "./UpperCaseText";

const statusMap = {
  CREATED: "created",
  RESERVATION_FAILED: "created",
  ORDER_RESERVED: "created",
  CONTRACT_REQUESTED: "confirmed",
  CONTRACT_REQUEST_FAILED: "confirmed",
  CONTRACT_FAILED: "confirmed",
  CONTRACT_CANCEL_REQUESTED: "ordered",
  CONTRACT_CANCEL_REQUEST_FAILED: "ordered",
  RESERVATION_CANCELLED: "cancelled",
  DEALER_CANCELLED: "cancelled",
  CONTRACT_CANCELLED: "cancelled",
  CONVERTED_TO_OFFLINE: "amended",
  AMENDED: "amended",
  ORDER_CONTRACTED: "contracted",
  ORDER_CONFIRMED: "submitted",
  CONTRACT_CANCEL_FAILED: "ordered",
  RESERVATION_CANCELLATION_FAILED: "contracted",
  AMEND_CONTRACT_REQUEST_FAILED: "contracted",
  AMEND_CONTRACT_CANCEL_REQUEST_FAILED: "contracted",
  ORDERED: "ordered",
  COMPLETED: "completed",
  ORDER_CANCELLED: "cancelled",
};

const CREATED_STATUSES = [
  "CREATED",
  "RESERVATION_FAILED",
  "ORDER_RESERVED",
  "CONTRACT_REQUESTED",
  "CONTRACT_REQUEST_FAILED",
  "CONTRACT_FAILED",
  "CONTRACT_CANCEL_REQUEST_FAILED",
  "ORDER_CONFIRMED",
  "NO_DEALER_ACTION",
  "CONTRACT_REFERRED",
  "DEALER_NOT_VALID",
];

const IS_NORWAY_MARKET = (market) => {
  return UpperCaseText(market) === "NOR";
};

const IS_SPAIN_MARKET = (market) => {
  return UpperCaseText(market) === "ESP";
};

const IS_ITALY_MARKET = (market) => {
  return UpperCaseText(market) === "ITA";
};

const IS_BELGIUM_MARKET = (market) => {
  return UpperCaseText(market) === "BEL";
};

const IS_SWISS_MARKET = (market) => {
  return UpperCaseText(market) === "CHE";
};

const IS_BRITAIN_MARKET = (market) => {
  return UpperCaseText(market) === "GBR";
};

const IS_AUSTRIA_MARKET = (market) => {
  return UpperCaseText(market) === "AUT";
};

const IS_NETHERLAND_MARKET = (market) => {
  return UpperCaseText(market) === "NLD";
};

const IS_GERMAN_MARKET = (market) => {
  return UpperCaseText(market) === "DEU";
};

const IS_IRELAND_MARKET = (market) => {
  return UpperCaseText(market) === "IRL";
};

const IS_HUNGARY_MARKET = (market) => {
  return UpperCaseText(market) === "HUN";
};

const IS_FRANCE_MARKET = (market) => {
  return UpperCaseText(market) === "FRA";
};

const IS_FORD_BRAND = (brand) => {
  return "F" === brand;
};

const DISPLAY_PROPOSAL_FOR_MARKET = (market) => {
  return ["GBR", "FRA", "DEU", "ITA", "ESP", "NLD"].includes(market); // Added NLD for proposal number display
};

const DISPLAY_PROPOSAL_FOR_MARKET_LEASE = (market) => {
  return ["GBR", "FRA", "DEU", "NLD"].includes(market);
};

const HAS_VALUE = (input) => {
  return input !== null && input !== undefined;
};

const NULL_OR_UNDEFINED = (input) => {
  return input === null || input === undefined;
};

const NOTNULL_OR_NOTUNDEFINED = (input) => {
  return !NULL_OR_UNDEFINED(input);
};

const FORMAT_COMMON_ID = (commonDealerId) => {
  return commonDealerId.split("|").join("%7C");
};

const IS_AGENT_DEALERTYPE = (dealerType) => {
  return UpperCaseText(dealerType) === "AGENT";
};

const ONLINE_TRADE_IN_MARKETS = ["DEU"];

const DEALER = "DEALER";
const AGENT = "AGENT";

const OFFLINE_TRADE_IN_MARKETS = [
  "NOR",
  "CHE",
  "AUT",
  "BEL",
  "CZE",
  "FIN",
  "GRC",
  "HUN",
  "IRL",
  "PRT",
  "POL",
  "ROU",
  "ESP",
  "ITA",
  "GBR",
  "FRA",
];

const SITE_ORIGIN =
  typeof window !== "undefined" && window.EMP ? window.EMP.SITE_ORIGIN : "";

const BASE_URL =
  typeof window !== "undefined" && window.EMP ? window.EMP.BASE_URL : "";

const RESERVATION_BASE_URL =
  typeof window !== "undefined" && window.RESERVATION_SERVICE
    ? window.RESERVATION_SERVICE.BASE_URL
    : "";

const RESERVATION_ACTION_URL =
  typeof window !== "undefined" && window.RESERVATION_SERVICE
    ? window.RESERVATION_SERVICE.ACTION_URL
    : "";

const SHARED_SERVICE_URL =
  typeof window !== "undefined" && window.EMP
    ? window.EMP.SHARED_SERVICE_URL
    : "";

const ENV = typeof window !== "undefined" && window.EMP ? window.EMP.ENV : "";

const BASE_PRICING_URL =
  typeof window !== "undefined" && window.PRICING
    ? window.PRICING.BASE_PRICING_URL
    : "";

const ACCESSORIES_PRICING_URL =
  typeof window !== "undefined" && window.PRICING
    ? window.PRICING.ACCESSORIES_PRICING_URL
    : "";

const AUTHORIZE_BASE_URL =
  typeof window !== "undefined" && window.AUTH_SERVICE
    ? window.AUTH_SERVICE.BASE_AUTHORIZE_URL
    : "";

const REPORTING_BASE_URL =
  typeof window !== "undefined" && window.REPORTING_SERVICE
    ? window.REPORTING_SERVICE.BASE_URL
    : "";

const TRANSLATION_BASE_URL =
  typeof window !== "undefined" && window.EMP ? window.EMP.TRANSLATION_URL : "";

const ENTRA_ENABLE =
  typeof window !== "undefined" && window.EMP
    ? !!window.EMP.ENTRA_ENABLE
    : false;

const ENTRA_URL =
  typeof window !== "undefined" && window.EMP ? window.EMP.ENTRA_URL || "" : "";

export {
  IS_FORD_BRAND,
  IS_NORWAY_MARKET,
  SITE_ORIGIN,
  BASE_URL,
  SHARED_SERVICE_URL,
  RESERVATION_BASE_URL,
  REPORTING_BASE_URL,
  RESERVATION_ACTION_URL,
  BASE_PRICING_URL,
  ACCESSORIES_PRICING_URL,
  AUTHORIZE_BASE_URL,
  TRANSLATION_BASE_URL,
  ENTRA_ENABLE,
  ENTRA_URL,
  ONLINE_TRADE_IN_MARKETS,
  OFFLINE_TRADE_IN_MARKETS,
  DISPLAY_PROPOSAL_FOR_MARKET,
  DISPLAY_PROPOSAL_FOR_MARKET_LEASE,
  HAS_VALUE,
  NOTNULL_OR_NOTUNDEFINED,
  NULL_OR_UNDEFINED,
  ENV,
  IS_SPAIN_MARKET,
  IS_ITALY_MARKET,
  IS_SWISS_MARKET,
  IS_BELGIUM_MARKET,
  FORMAT_COMMON_ID,
  IS_BRITAIN_MARKET,
  IS_AUSTRIA_MARKET,
  IS_NETHERLAND_MARKET,
  IS_GERMAN_MARKET,
  IS_IRELAND_MARKET,
  IS_HUNGARY_MARKET,
  IS_FRANCE_MARKET,
  DEALER,
  AGENT,
  IS_AGENT_DEALERTYPE,
  statusMap,
  CREATED_STATUSES,
};
